import axios, { buildApi } from '@/libs/api.request';
let name = ''

export const apis = buildApi({
  get: ['/tracker/Trace/getTraceList&list',],
  post: ['/tracker/Trace/saveTrace', '/tracker/Trace/batchSaveTrace']
})


